<template>
  <div class="flex items-center gap-2 w-full">
    <div
      class="bg-ontick-carbon-900 relative h-1 rounded-full overflow-hidden w-full lg:w-[88px]"
      :class="{ rtl: progress < 0 }"
    >
      <div
        v-if="progress > 0"
        class="to-ontick-green-600 via-ontick-green-600 absolute inset-0 left-1/2 top-0 rounded-r-full bg-gradient-to-r from-transparent transition-all"
        :style="`width: ${width}%;`"
      ></div>
      <div
        v-if="progress < 0"
        class="to-ontick-red-600 via-ontick-red-600 absolute inset-0 right-1/2 top-0 rounded-l-full bg-gradient-to-l from-transparent transition-all"
        :style="`width: ${width * -1}%;`"
      ></div>
    </div>
    <span class="text-xs text-gray-400 font-normal w-16 hidden lg:block">
      {{ variation }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    symbol: {
      type: String,
    },
    entry_price: {
      type: Number,
    },
    direction: {
      type: String,
    },
    target: {
      type: Number,
    },
    target_type: {
      type: String,
    },
  },

  computed: {
    ...mapGetters({ getSymbolPrice: "marketdata/getSymbolPrice" }),
    progress() {
      let progress = 0;
      let entry = this.entry_price;
      let symbol = this.symbol;
      let direction = this.direction;
      let current_price = this.getSymbolPrice(symbol, direction == "BUY" ? "bid_price" : "ask_price");
      let target_type = this.target_type;
      let target = target_type == "PERCENT" ? this.target / 100 : this.target;
      let profit = 0;

      profit = current_price - entry;

      if (target_type == "PERCENT") {
        progress = (profit / (entry * target)) * 100;
      } else {
        progress = (profit / target) * 100;
      }

      if (progress > 100 || progress < -100) {
        return 0;
      }

      if (direction == "SELL") {
        progress = progress * -1;
      }

      return progress;
    },
    variation() {
      let { entry_price, symbol, direction, target_type, target } = this;
      let current_price = this.getSymbolPrice(symbol, direction == "BUY" ? "bid_price" : "ask_price");
      let variation = 0;

      if (target_type == "PERCENT") {
        if (!this.progress) {
          return variation.toFixed(2) + "%";
        }
        variation = current_price - entry_price;
        // return (variation / (entry_price * (target / 100))).toFixed(2) + "%";
        return ((variation / entry_price) * 100).toFixed(2) + "%";
      } else {
        if (!this.progress) {
          return variation + "p";
        }
        variation = current_price - entry_price;
        return variation + "p";
      }
    },
    width() {
      return this.progress / 2;
    },
  },
};
</script>

<style lang="scss" scoped>
.rtl {
  direction: rtl;
}
</style>
